import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { FaEdit } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { getBannerById } from '../api/bannerApi'

const BannerImage = ({ bannerId }) => {
  const { data: dealData } = useQuery({
    queryKey: ['banner', bannerId],
    queryFn: () => getBannerById(bannerId),
  })

  console.log('image hai:', dealData)

  return (
    <div className="bg-white text-left shadow-md rounded-lg p-4 w-full sm:w-[90%] mx-auto">
      <h3 className="text-xl text-[#4E4A4A] font-semibold mb-2">
        Banner Image
      </h3>
      <img
        src={dealData?.image}
        alt="banner"
        className="w-full object-cover h-60 rounded border-gray-400 border"
      />
      <div className="flex items-center justify-center mt-4">
        <Link
          to={`/dealdashboard/edit/banner/${bannerId}`}
          className="text-green-600 hover:text-green-800 flex items-center"
        >
          <FaEdit className="mr-1" /> Edit
        </Link>
      </div>
    </div>
  )
}

export default BannerImage
